// eslint-disable-next-line no-unused-vars
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import asyncPoll from 'react-async-poll';

import { actions as notificationsActions } from 'features/notifications';

const AsyncPollNotifications = () => null;

function mapStateToProps(state) {
  return {
    isAuth: state.auth.isAuth,
  };
}

function mapDispatchToProps(dispatch) {
  const actions = {
    getNotifications: notificationsActions.getNotifications,
  };
  return bindActionCreators(actions, dispatch);
}

function onPollInterval(props) {
  if (props.isAuth) {
    props.getNotifications();
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(asyncPoll(10 * 2000, onPollInterval)(AsyncPollNotifications));
